<template>
    <div class="page-table listPage mainDiv mb-30" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Bonus List

            <div class="tanimlamaButon">
                <el-tooltip :content='$t("src.views.apps.genel.refresh")'
                    :open-delay="500"
                    placement="top">
                    <el-button
                    v-on:click="refreshPage()"
                    size="mini"
                    type="text"
                    icon="el-icon-refresh">
                    </el-button>
                </el-tooltip>
            </div>
        </div>

        <el-row :gutter="10">
            <el-col :lg="!bonusGuncelleme ? 24 : 18" :md="!bonusGuncelleme ? 24 : 18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp" v-loading="loading || stateLoading"
                :element-loading-text='loading ? "Bonus List is Loading. Please Wait" : "Bonus Status is Changing. Please Wait"'
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 1)">
                <el-row class="mt-0 mb-10">
                    <el-col :lg="16" :md="16" :sm="24" :xs="24">
                        <div>
                            <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9" text-color="gray">
                                <el-radio-button label="0">
                                    <i class="mdi mdi-page-next mdi-18px" style="color: #556378; margin-right: 5px"></i>
                                    <transition name="slide-fade">
                                        <label v-if="selectIcon == '0'">Not Used</label>
                                    </transition>
                                </el-radio-button>

                                <el-radio-button label="1">
                                    <i class="mdi mdi-page-next mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                    <transition name="slide-fade">
                                        <label v-if="selectIcon == '1'">Used</label>
                                    </transition>
                                </el-radio-button>

                                <el-radio-button label="2">
                                    <i class="mdi mdi-page-next mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                    <transition name="slide-fade">
                                        <label v-if="selectIcon == '2'">Canceled</label>
                                    </transition>
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                    </el-col>

                    <el-col :lg="8" :md="8" :sm="24" :xs="24">
                        <el-col :lg="24" :md="24" :sm="24" :xs="24">
                            <ul class="islemler">
                                <li class="duzenle">
                                    <i class="mdi mdi-pen"></i> {{$t("src.views.apps.rakamlar.islem.duzenle")}}
                                </li>
                                <li class="sil">
                                    <i class="mdi mdi-close"></i> Cancel
                                </li>
                                <li v-if="selectIcon === '0'" class="aktif">
                                    <i class="mdi mdi-play"></i>Set as Used
                                </li>
                            </ul>
                        </el-col>
                    </el-col>
                </el-row>

                <el-table border stripe :data="bonusListe" style="width: 100%" v-if="bonusListe.length > 0">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div class="right-box box grow">
                                <blockquote>
                                    <small class="secondary-text"> {{props.row.mail}}</small>
                                    <p class="yorum-expand">{{props.row.indirimNotu}}</p>


                                    <small v-if="selectIcon == '2'" class="secondary-text">Reason for Cancellation</small>
                                    <p v-if="selectIcon == '2'" class="yorum-expand">{{props.row.iptalSebebi}}</p>
                                    
                                </blockquote>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label='$t("src.views.apps.genel.sira")'
                        type="index"
                        :index="indexMethod"
                        width="80">
                    </el-table-column>
                    <el-table-column
                        label='Bonus ID'
                        prop="bonusID"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        label='Customer ID'
                        prop="musteriID"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="mail"
                        :label='"E-Mail"'
                        :width="!bonusGuncelleme ? 'auto' : '300'">
                    </el-table-column>
                    <el-table-column
                        prop="telefon"
                        :label='"Telephone"'
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="bonusFiyati"
                        :label='"Bonus Price"'
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="bonusDurum"
                        :label='"Bonus Status"'
                        width="120">
                        <template slot-scope="prop">
                            <div v-if="prop.row.bonusDurum == '0'">Not Used</div>
                            <div v-if="prop.row.bonusDurum == '1'">Used</div>
                            <div v-if="prop.row.bonusDurum == '2'">Cancel</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="sonKullanmaTarihi"
                        :label='"Expiration date"'
                        width="170">
                    </el-table-column>
                   
                    <el-table-column
                        :label='$t("src.views.apps.genel.islem")'
                        fixed="right"
                        align="right"
                        width="150">
                        <template slot-scope="scope">
                            <el-tooltip :content='$t("src.views.apps.rakamlar.islem.duzenle")' :open-delay="500" placement="bottom">
                                <el-button
                                    v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row, 'bonusForm'); "
                                    type="text"
                                    style="color: #f7ba2a; margin-left: 15px !important;"
                                    icon="mdi mdi-pen mdi-24px">
                                </el-button>
                            </el-tooltip>
                            <el-tooltip :content='"Cancel"' :open-delay="500" placement="bottom">
                                <el-button
                                    v-if="selectIcon === '1' || selectIcon === '0'"
                                    v-on:click="bonusIptalDialogData = scope.row; bonusIptalDialog = true"
                                    type="text"
                                    class="buttonDel"
                                    style="margin-left: 15px !important;"
                                    icon="mdi mdi-close mdi-24px">
                                </el-button>
                            </el-tooltip>
                            <el-tooltip :content='"Set as Used"' :open-delay="500" placement="bottom">
                                <el-button
                                    v-if="selectIcon === '0'"
                                    v-on:click="bonusStatusChange(scope.row,'1')"
                                    type="text"
                                    class="buttonDel"
                                    style="margin-left: 15px !important; color: #13ce66"
                                    icon="mdi mdi-play mdi-24px">
                                </el-button>
                            </el-tooltip>
                            
                        </template>
                     </el-table-column>
                </el-table>

                <div v-else style="height: 100px; display: flex; justify-content: center; align-items: center">
                    There is no bonus to show.
                </div>

                <el-pagination
                    v-if="bonusListe.length > 0"
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
                </el-pagination>
            </div>
            </el-col>

            <el-col v-if="bonusGuncelleme" :lg="bonusGuncelleme ? 6 : 0" :md="bonusGuncelleme ? 6 : 0" :sm="bonusGuncelleme ? 24 : 0" :xs="bonusGuncelleme ? 24 : 0">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInRight pb-20" v-loading="updateLoading"
                :element-loading-text='"Bonus is Updating. Please Wait"'
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 1)">
                    <el-form status-icon :model="bonusForm" :rules="bonusFormRules" ref="bonusForm" class="demo-ruleForm">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='"Discount Price"' prop="price">:
                                    <el-input v-model="bonusForm.bonusFiyati" v-mask="['#,##', ' ##,##', ' ###,##', '#.###,##', '##.###,##', '###.###,##']" :placeholder='"Enter Discount Price"'></el-input>
                                </el-form-item>
                            </el-col>

                             <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='"Limit Price to Apply Discount"' prop="eposta">:
                                    <el-input v-model="bonusForm.kullanmaLimiti" v-mask="['#,##', ' ##,##', ' ###,##', '#.###,##', '##.###,##', '###.###,##']" :placeholder='"Enter Limit Price"'></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='"Expiration date"' prop="eposta">:
                                    <el-date-picker v-model="bonusForm.sonKullanmaTarihi" type="datetime" placeholder="Select Expiration Date and Time" style="width: 100%"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='"Discount Note"' prop="telefon">:
                                    <el-input v-model="bonusForm.indirimNotu" :placeholder='"Enter Discount Note"' type="textarea" :autosize="{ minRows: 2, maxRows: 10}"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='"Discount Note"' prop="telefon">:
                                    <el-select v-model="bonusForm.durum" placeholder="Select Status" style="width: 100%; margin-bottom:10px !important">
                                        <el-option value="0" label="Not Used"></el-option>
                                        <el-option value="1" label="Used"></el-option>
                                        <el-option value="2" label="Canceled"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <div style="display: flex; justify-content: end">
                                    <el-button type="danger" @click="cancelUpdate('bonusForm')">Cancel</el-button>
                                    <el-button type="success" @click="updateBonus('bonusForm')">Update</el-button>
                                </div>
                            </el-col>
                        </el-row>

                    </el-form>
                </div>
            </el-col>
        </el-row>


        <el-dialog :title='"Cancel Bonus"' :visible.sync="bonusIptalDialog" width="50%" center>
            <el-row v-loading="stateLoading"
                :element-loading-text='"Bonus Status is Changing. Please Wait"'
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 1)">

                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form status-icon :model="bonusIptalDialogForm" :rules="bonusIptalDialogRules" ref="bonusIptalDialogForm" class="demo-ruleForm">
                        <el-col :lg="24" :md="24" :sm="24" :xs="24">
                            <el-form-item :label='"Cancel Message"' prop="bonusIptalSebebi">:
                                <el-input v-model="bonusIptalDialogForm.bonusIptalSebebi" type="textarea" :autosize="{ minRows: 3, maxRows: 10}" :placeholder='"Enter Cancel Message"'></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-col>

                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div style="float: right; padding-right : 15px">
                        <el-button type="danger" @click="bonusIptalDialogCancel('bonusIptalDialogForm')">Cancel</el-button>
                        <el-button type="success" @click="bonusStatusChange(bonusIptalDialogData, '2')">Change Status</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>

    </div>
</template>

<script>

    import bonusService from '../../../WSProvider/BonusService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import JQuery from 'jquery';
    import EventBus from '@/components/event-bus'

    let $ = JQuery;
    import '@fortawesome/fontawesome-free/css/all.css'
    import '@fortawesome/fontawesome-free/js/all.js'

    var moment = require('moment')

    export default {
        name: "Bonus",
        components: {
        },
        mounted() {
            this.getBonusList();

            var self = this
            EventBus.$on("bonusList", () => {
                self.getBonusList();
            })
        },
        watch: {
            page(val) {
                this.postPage = (val - 1) * this.sizes;
            }
        },
        data() {
            return {
                bonusGuncelleme: false,

                loading: false,
                updateLoading: false,
                stateLoading: false,
                addLoading: false,
                selectIcon: '0',
                radio: '0',
                bonusListe: [],
                selection: '',
                selectionIndex: '',

                sizes: 10,
                page: 0,
                postPage: 0,
                total: null,

                bonusForm: {
                    musteriMail: "",
                    musteriID : "",
                    musteriAdi: "",
                    bonusID: "",
                    bonusFiyati: "",
                    kullanmaLimiti: "",
                    indirimNotu: "",
                    sonKullanmaTarihi: "",
                    durum: "",
                },
                bonusFormRules: {},

                bonusIptalDialog: false,
                bonusIptalDialogData: {},
                bonusIptalDialogForm: {
                    bonusIptalSebebi : "",
                },
                bonusIptalDialogRules: {
                    bonusIptalSebebi: [{required: true, message: "Please Enter Bonus Cancel Message", trigger: ['blur', 'change'] }],
                },

            }
        },
        methods: {
            cancelUpdate(formName){
                this.$confirm("Are you sure you want to reset form?", this.$t("src.views.apps.marka.tanimlama.warning"), {
                    confirmButtonText: this.$t("src.views.apps.genel.yes"),
                    cancelButtonText: this.$t("src.views.apps.genel.no"),
                    type: 'warning'
                }).then(() => {
                    this.vazgec(formName)
                    this.bonusGuncelleme = false
                }).catch(() => {

                })
            },

            updateBonus(formName){
                this.$confirm("Are you sure you want to update bonus?", this.$t("src.views.apps.marka.tanimlama.warning"), {
                    confirmButtonText: this.$t("src.views.apps.genel.yes"),
                    cancelButtonText: this.$t("src.views.apps.genel.no"),
                    type: 'warning'
                }).then(() => {
                     this.$refs[formName].validate((valid, errors) => {
                        if(valid){
                            try{
                                this.updateLoading = true;
                                var bonusFiyat = functions.formatMoney(this.bonusForm.bonusFiyati)
                                var kullanmaLimiti = functions.formatMoney(this.bonusForm.kullanmaLimiti);
                                var expiration = moment(this.bonusForm.sonKullanmaTarihi).format("YYYY-MM-DD hh:mm:ss");
                                //musteriID, bonusFiyati, kullanmaLimiti, indirimNotu, sonKullanmaTarihi, durum
                                bonusService.bonusGuncelle(this.bonusForm.musteriID, this.bonusForm.bonusID, bonusFiyat, kullanmaLimiti, this.bonusForm.indirimNotu, expiration, this.bonusForm.durum).then((response) => {
                                    if(response.status == 200){
                                        notification.Status("success", this, "Bonus successfully added.")
                                        this.vazgec(formName);
                                    }
                                    this.updateLoading = false;
                                    this.getBonusList();
                                }).catch(err => {                              
                                    if(err.responseJSON){
                                        let error = err.responseJSON
                                        if(error.status == 401){
                                            notification.Status(150, this);
                                        }
                                        else notification.Status("errorMsg", this, error.errMsg)
                                    }else{
                                        // notification.Status(503, this)
                                    }
                                    this.updateLoading = false;
                                })
                            }catch(e){
                                notification.Status("danger", this, "An error occurred while updating the bonus.")
                                this.updateLoading = false;
                            }
                        }else{
                            for(var k in errors){
                                errors[k].forEach((element) => {
                                    notification.Status( "warning", this, element.message);
                                })  
                            }
                            this.addBonusDialogLoading = false;
                            this.updateLoading = false;
                        }
                    })
                }).catch(() => {

                })
            },

            refreshPage(){
                this.loading = false;
                this.stateLoading = false;
                this.addLoading = false;
                this.updateLoading = false;
                this.page = 1;
                this.postPage = 0;
                this.getBonusList();
                this.bonusGuncelleme = false;
            },

            handleChange(event) {
                this.selectIcon = event;
                this.postPage = 0;
                this.getBonusList();
            },

            getBonusList() {
                try{
                    this.loading = true;
                    bonusService.bonusListele(this.selectIcon, this.postPage, this.sizes).then((response) => {
                        if (response.status == 200) {
                            localStorage.setItem("userDataDosPharmacy", response.token);
                            this.bonusListe = response.data.data;
                            this.total = response.data.count
                        }
                        this.loading = false;
                    }).catch(err => {
                        if(err.responseJSON){
                            let error = err.responseJSON
                            if(error.status == 401){
                                notification.Status(150, this);
                            }else if(error.status == 404){
                                this.bonusListe = [];
                            }
                            else notification.Status("errorMsg", this, error.errMsg)
                        }else{
                            // notification.Status(503, this)
                        }
                        this.loading = false;
                    })
                }catch(e){
                    notification.Status("danger", this, "An error occurred while fetching the bonus list.");
                    this.loading = false;
                }
            },

            updateStart(scope, formName) {

                this.bonusForm.bonusFiyati = functions.decodeMoney(scope.bonusFiyati)
                this.bonusForm.kullanmaLimiti = functions.decodeMoney(scope.kullanmaLimiti)

                this.bonusGuncelleme = true
                this.bonusForm.musteriMail = scope.mail
                this.bonusForm.musteriID = scope.musteriID
                this.bonusForm.musteriAdi = scope.adSoyad
                this.bonusForm.bonusID = scope.bonusID
                this.bonusForm.indirimNotu = scope.indirimNotu
                this.bonusForm.sonKullanmaTarihi = moment(scope.sonKullanmaTarihi).format("YYYY-MM-DD hh:mm:ss")
                this.bonusForm.durum = scope.bonusDurum
            },

            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.bonusIptalDialog = false;
                this.updateLoading = false;
                this.stateLoading = false;
                this.loading = false;
                this.bonusGuncelleme = false;
            },


            bonusStatusChange(selection ,durum) {
                var durumText = durum == '1' ? " as Used?" : " as Canceled?"
                this.$confirm("Are you sure you want to update number's status" + durumText, this.$t("src.views.apps.marka.tanimlama.warning"), {
                    confirmButtonText: this.$t("src.views.apps.genel.yes"),
                    cancelButtonText: this.$t("src.views.apps.genel.no"),
                    type: 'warning'
                }).then(() => {
                    try{
                        this.stateLoading = true;
                        bonusService.bonusDurumDegistir(selection.bonusID, durum, this.bonusIptalDialogForm.bonusIptalSebebi).then(response => {
                            if (response.status == 200) {
                                localStorage.setItem("userDataDosPharmacy", response.token)
                                this.getBonusList();
                                this.stateLoading = false;
                            }
                            notification.Status("success", this, response.msg)
                        }).catch(err => {
                            if(err.responseJSON){
                                let error = err.responseJSON
                                if(error.status == 401){
                                    notification.Status(150, this);
                                }
                                else notification.Status("errorMsg", this, error.errMsg)
                            }else{
                                // notification.Status(503, this)
                            }
                            this.stateLoading = false;
                        })
                    }catch(e){
                        console.log({e})
                        notification.Status("danger", this, "An error occurred while updating bonus status.");
                        this.stateLoading = false;
                    }
                })
                
            },

            formTemizle(formName) {
                this.$refs[formName].resetFields();
            },

           handleSizeChange(val) {
                this.sizes = val;
                this.getBonusList();
            },

            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getBonusList();
            },

            indexMethod(index){
                return ((this.page - 1)* 10) + index + 1;
            },
        }
    }
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';
    .el-pagination {
        margin-top: 20px;
        float: right;
    }
</style>

<style scoped>
    .yorum-expand{
        word-wrap: break-word;
    }

</style>